module.exports = __webpack_public_path__ + "media/images/en/rejected-0c587fa3be754079386904f287f06074.png";